import React, { useState } from 'react';
import { Play } from 'lucide-react';
import Voices from './Voices';
import { useVoices } from '../hooks/useVoices';

const VoicesPanel = ({
  selectedName,
  setSelectedName,
  data,
}: {
  selectedName: string;
  setSelectedName: (name: string) => void;
  data: any;
}) => {
  return (
    <div className="max-w-3xl mx-auto lg:p-6 bg-background">
      <div className="flex gap-8">
        <Voices
          names={data?.female || []}
          selectedName={selectedName}
          setSelectedName={setSelectedName}
          title="FEMALE"
        />
        <Voices
          names={data?.male || []}
          selectedName={selectedName}
          setSelectedName={setSelectedName}
          title="MALE"
        />
      </div>

      <div className=" bg-[#202020] rounded-lg p-2 flex justify-center items-center space-x-4">
        <div className=" rounded p-2 w-18 h-12  flex items-center justify-center">
          <img src="/ttsceleb.png" alt="celebrity" />
        </div>
        <p className="text-white text-lg">
          Celebrity voices coming soon. Stay tuned!
        </p>
      </div>
    </div>
  );
};

export default VoicesPanel;
